import { Vue, Component, Ref, Prop, Emit, Provide } from 'vue-property-decorator'
import ConfigurationAutomationGrossingShelfIntermediateShelfProcessModalBasicForm
    from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/components/modal-basic-form/configuration-automation-grossing-shelf-intermediate-shelf-process-modal-basic-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationAutomationGrossingShelfIntermediateShelfProcessModalState,
    initialConfigurationAutomationGrossingShelfIntermediateShelfProcessModalState
} from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/components/modal/configuration-automation-grossing-shelf-intermediate-shelf-process-modal.model'
import {
    ConfigurationIntermediateShelfSampleProcessAssignmentCreateRequest,
    ConfigurationIntermediateShelfSampleProcessAssignmentPatchInBatchRequest,
    ConfigurationIntermediateShelfSampleProcessAssignmentResponse
} from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-intermediate-shelf-sample-process-assignment/configuration-intermediate-shelf-sample-process-assignment.dto'

@Component({
    components: {
        ConfigurationAutomationGrossingShelfIntermediateShelfProcessModalBasicForm
    }
})
export default class ConfigurationAutomationGrossingShelfIntermediateShelfProcessModal extends Vue {
    @Ref() readonly intermediateShelfProcessModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Provide() externalValidator = this.$validator

    @Emit()
    create(): ConfigurationIntermediateShelfSampleProcessAssignmentCreateRequest {
        return {
            sampleProcessId: this.state.intermediateShelfSampleProcessAssignment.sampleProcess?.id!
        }
    }

    @Emit()
    update(): ConfigurationIntermediateShelfSampleProcessAssignmentPatchInBatchRequest {
        return {
            id: this.state.intermediateShelfSampleProcessAssignment.id!,
            sampleProcessId: this.state.intermediateShelfSampleProcessAssignment.sampleProcess?.id!
        }
    }

    state: ConfigurationAutomationGrossingShelfIntermediateShelfProcessModalState

    get updateMode(): boolean {
        return !!this.state.intermediateShelfSampleProcessAssignment?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialConfigurationAutomationGrossingShelfIntermediateShelfProcessModalState()
    }

    async show(intermediateShelfSampleProcessAssignment?: ConfigurationIntermediateShelfSampleProcessAssignmentResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAutomationGrossingShelfIntermediateShelfProcessModalState()
        if (intermediateShelfSampleProcessAssignment) {
            this.state.intermediateShelfSampleProcessAssignment = intermediateShelfSampleProcessAssignment
        }

        this.intermediateShelfProcessModal.show()
    }

    hide(): void {
        this.intermediateShelfProcessModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.state.intermediateShelfSampleProcessAssignment) {
                if (this.updateMode) {
                    this.update() // emits an event
                } else {
                    this.create() // emits an event
                }
            }

            this.hide()
        }
    }
}
